(function () {
  'use strict';
  if (window.LPAPOOptionHelp) { window.LPAPOOptionHelp.init(); return; }

  // 值标题(大小写不敏感) -> 点击 "?" 后弹窗文案。仅 Pick for me / Original 会加 "?"。
  const HELP_MAP = {
    'we pick': 'Not sure on a background? Let us design one that fits your pet. Feel free to leave a note at checkout if you have a preference.',
    'original': 'Prefer to keep the original background from your photo? No problem!  Feel free to leave a note at checkout if you have a preference.'
  };

  const VALUE_TITLE_SELECTOR =
    '.mw-stack--card__title, .mw-option__value-title, .mw-option__value-text, .mw-stack--wide__content-title';

  let dialog;
  let opener;

  function valueTitle(value) {
    const title = value.querySelector(VALUE_TITLE_SELECTOR);
    return title ? title.textContent.replace(/\*/g, '').trim().toLowerCase() : '';
  }

  function showDetails(button, copy) {
    opener = button;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'lp-2d-video-details'; // 复用奶油色弹窗观感
      dialog.setAttribute('aria-label', 'Background option info');
      const text = document.createElement('p');
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'lp-2d-video-details__close';
      close.setAttribute('aria-label', 'Close');
      close.textContent = '×';
      close.addEventListener('click', () => dialog.close());
      dialog.append(close, text);
      dialog.addEventListener('close', () => { if (opener && opener.isConnected) opener.focus(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      document.body.append(dialog);
    }
    dialog.querySelector('p').textContent = copy;
    if (!dialog.open) dialog.showModal();
  }

  function enhance(root) {
    root.querySelectorAll('.mw-option__value').forEach(value => {
      const copy = HELP_MAP[valueTitle(value)];
      if (!copy) return; // 仅给 Pick for me / Original 加 "?"
      const fill = value.querySelector('.mw-stack--card__fill-items');
      if (!fill) return;
      let button = fill.querySelector('.lp-apo-option-help__btn');
      if (button && button.closest('.lp-apo-option-help__title-row')) return; // 已就位，幂等
      const title = fill.querySelector('.mw-stack--card__title') ||
        fill.querySelector(VALUE_TITLE_SELECTOR);
      if (!title) return;
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = 'lp-apo-option-help__btn';
        button.setAttribute('aria-label', 'More info');
        button.setAttribute('aria-haspopup', 'dialog');
        button.textContent = '?';
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          showDetails(button, copy);
        });
      }
      // .mw-stack--card__fill-items 是纵向堆叠，直接 append 会让 "?" 掉到下一行；
      // 把标题包进横向行容器，"?" 才能跟在标题后面。标题类名不变，不影响其它选择器。
      let row = title.parentElement;
      if (!row.classList.contains('lp-apo-option-help__title-row')) {
        row = document.createElement('div');
        row.className = 'lp-apo-option-help__title-row';
        title.before(row);
        row.append(title);
      }
      row.append(button);
    });
  }


  const HEADER_HELP_COPY = 'Add Matching Pet Gifts, made from the same photo. Preview in 2 biz days, then wrapped and shipped together with your portrait.';
  const HEADER_HELP_TITLES = ['matching pet gifts'];

  function isHeaderTitle(element) {
    const own = Array.from(element.childNodes)
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .map(node => node.textContent).join(' ')
      .replace(/\s+/g, ' ').trim().toLowerCase();
    return !!own && HEADER_HELP_TITLES.some(text => own.includes(text));
  }

  function enhanceHeader(scope) {
    (scope || document).querySelectorAll('h1, h2, h3, h4, h5, h6, .mw-label, .mw-text, .mw-stack--card__title, .mw-option__value-title, .mw-option__value-text, .mw-stack--wide__content-title')
      .forEach(title => {
      if (!isHeaderTitle(title)) return;
      let row = title.parentElement;
      if (!row.classList.contains('lp-apo-option-help__title-row')) {
        row = document.createElement('div');
        row.className = 'lp-apo-option-help__title-row';
        title.before(row);
        row.append(title);
      }
      if (row.querySelector('.lp-apo-info-help__btn')) return; // 幂等
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lp-apo-option-help__btn lp-apo-info-help__btn';
      button.setAttribute('aria-label', 'More info');
      button.setAttribute('aria-haspopup', 'dialog');
      button.textContent = '?';
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        showDetails(button, HEADER_HELP_COPY);
      });
      row.append(button);
    });
  }
  
  
  function init(scope) {
    enhance(scope || document);
  }

  window.LPAPOOptionHelp = { init };
  init();

  // APO 重渲染后补注入（rAF 防抖；enhance 内部已做幂等判定，不会重复加按钮）
  let frame;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => enhance(document));
  };
  const host = document.querySelector('.product__info-container') || document.body;
  new MutationObserver(schedule).observe(host, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden', 'aria-hidden', 'style']
  });
  document.addEventListener('shopify:section:load', event => init(event.target));

    let headerFrame;
  const scheduleHeader = () => {
    cancelAnimationFrame(headerFrame);
    headerFrame = requestAnimationFrame(() => enhanceHeader(document));
  };
  new MutationObserver(scheduleHeader).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden', 'aria-hidden', 'style']
  });
})();
